import Header from '../components/Header';
import ListeServices from '../components/ListeServices.js';
import Footer from '../components/Footer';

const sections=[
    {
        categorie: 'Ingénierie',
        services:[
            {
                titre: 'Développement de sites web, d\'applications mobiles et de logiciels',
                image: '/images/DevWeb.avif',
                description: 'i2c mobilise ses compétences en développement pour créer des solutions numériques adaptées à vos besoins.',
                lien: '/services/developpement-web',
            },
            {
                titre: 'Création et refonte de base de données',
                image: '/images/bdd.avif',
                description: 'i2c conçoit et optimise vos bases de données pour une gestion fluide, rapide et parfaitement intégrée à vos projets.',
                lien: '/services/base-de-donnees',
            },
            {
                titre: 'Intelligence artificielle et algorithmie',
                image: '/images/AI.avif',
                description: 'i2c développe des solutions intelligentes et des algorithmes sur mesure pour automatiser vos processus et enrichir vos interfaces.',
                lien: '/services/intelligence-artificielle',
            }
        ]

    },
    {
        categorie: 'Cognitique',
        services: [
            {
                titre: 'Knowledge management (Gestion des connaissances)',
                image: './images/knowledge-management.avif',
                description: 'i2c structure et capitalise vos savoirs organisationnels pour en garantir la pérennité et faciliter leur partage.',
                lien: '/services/knowledge-management',
            },
            {
                titre: 'UX/UI Design',
                image: '/images/UXDesign.avif',
                description: 'i2c conçoit des interfaces intuitives et esthétiques qui garantissent une expérience utilisateur fluide et optimale.',
                lien: '/services/ux-design',
            },
            {
                titre: 'Méthodes de Conception Centrée Utilisateur',
                image: '/images/CCU.avif',
                description: 'i2c applique des méthodes centrées utilisateur pour concevoir des produits qui répondent aux véritables besoins de vos usagers.',
                lien: '/services/ccu',
            },
        ],
    },
    {
         categorie: 'Conseil',
        services: [
            {
                titre: 'Analyse statistique',
                image: '/images/analyseStat.avif',
                description: 'i2c exploite vos données pour en extraire des insights clés et orienter vos décisions stratégiques.',
                lien: '/services/analyse-statistique',
            },
            {
                titre: 'Audit Ergonomique',
                image: '/images/audit.avif',
                description: 'i2c analyse vos interfaces pour identifier les points de friction et proposer des solutions ergonomiques adaptées.',
                lien: '/services/audit-ergonomique',
            },
            {
                titre: 'Conseil en accessibilité et handicap',
                image: '/images/access.avif',
                description: 'i2c accompagne vos équipes pour rendre vos produits numériques accessibles à tous, selon les normes en vigueur.',
                lien: '/services/conseil-handicap',
            },
        ],
    }
    
]
function Services(){
    return(
        <div>
            <Header/>
            {/* Encadré pour le titre */}
            <div className="dark:bg-bleu-gris ">
             <div className="text-gris-sombre"></div>
              <div className="flex flex-col items-center ">
                <div className="relative text-center h-[300px] w-full overflow-hidden">
                <div className="absolute top-[30%] w-full flex flex-col justify-center items-center text-gris-sombre space-y-2">
                    <h2 className="px-6 font-comme font-bold text-[40px] md:text-[54px] lg:text-[64px] leading-tight text-center text-gris-sombre dark:text-blanc-sombre">
                    Services et réalisations
                    </h2>
                </div>
                </div>
                </div>
                
        </div>
            {/* Contenu de la page */}
            <div className="bg-white dark:bg-fond-sombre px- pb-2">

                {sections.map((section) => (
                    <div key={section.categorie} className="max-w-6xl mx-auto mb-20">

                        {/* Titre de section */}
                        <h3 className="text-gris-sombre dark:text-blanc-sombre text-[32px] font-semibold text-center pt-10 pb-8">
                            Notre offre de prestation en{' '}
                            <span className="text-bleu-je">{section.categorie}</span>
                        </h3>

                        {/* Grille de cartes */}
                        <div className="flex flex-col items-center md:flex-row md:flex-wrap md:justify-center gap-8">
                            {section.services.map((service) => (
                                <ListeServices
                                    key={service.lien}
                                    image={service.image}
                                    titre={service.titre}
                                    description={service.description}
                                    lien={service.lien}
                                />
                            ))}
                        </div>
                    </div>
                ))}

            </div>

            <Footer />
        </div>
    );

}
export default Services;